export default "__VITE_ASSET__BYYUQaXW__"